import styled, { css } from 'styled-components';

interface ILabelProps {
  isFocused: boolean;
  isErrored?: boolean;
}

export const Label = styled.label<ILabelProps>`
  ${({ theme, isFocused }) => css`
    font-size: ${theme.fontSizes.small};
    font-weight: ${theme.weight.veryStrong};

    ${isFocused &&
    css`
      color: ${theme.colors.primary};
    `}
  `}
`;

export const Container = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    font-size: ${theme.fontSizes.large};
  `}
`;

export const WindowedSelectWrapper = styled.div`
  width: 100%;
`;

export const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
`;
